module.exports = __webpack_public_path__ + "img/Frame-41.2388d914.svg";